import { Check } from 'lucide-react';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { DiscordAddToServerCta } from './DiscordAddToServerCta';

export const DiscordAutomaticIdle = ({
  setupForm,
  connectedGuildName,
}: {
  setupForm: ReactNode;
  connectedGuildName: string | null;
}) => {
  const { t } = useTranslation('getting_started');
  const isConnected = connectedGuildName !== null;

  return (
    <div data-brand="discord" data-testid="gs-discord-idle" className="flex w-full flex-col gap-6">
      {isConnected && (
        <div
          className="mx-auto flex w-full max-w-sm items-start gap-3 rounded-lg border border-[var(--qc-discord-border)] bg-[var(--qc-discord-surface-2)] px-4 py-3"
          data-testid="gs-discord-connected-confirmation"
        >
          <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-full bg-[var(--qc-discord-blurple)]">
            <Check className="size-3.5 text-white" />
          </span>
          <div className="flex min-w-0 flex-col gap-1">
            <p className="break-words text-sm font-semibold text-[var(--qc-discord-on-surface)]">
              {connectedGuildName
                ? t('automatic_flow.discord.connected_title', { server: connectedGuildName })
                : t('automatic_flow.discord.connected_title_generic')}
            </p>
            <p className="text-xs text-[var(--qc-discord-muted)]">
              {t('automatic_flow.discord.connected_subtitle')}
            </p>
          </div>
        </div>
      )}

      {setupForm}

      {!isConnected && (
        <div className="mx-auto flex w-full max-w-sm flex-col gap-4">
          <div
            className="my-1 flex items-center gap-3 text-xs uppercase tracking-wider text-[var(--qc-discord-muted)]"
            data-testid="gs-discord-or-divider"
          >
            <div className="h-px flex-1 bg-[var(--qc-discord-border)]" />
            <span>{t('automatic_flow.or')}</span>
            <div className="h-px flex-1 bg-[var(--qc-discord-border)]" />
          </div>
          <DiscordAddToServerCta source="first_page" />
        </div>
      )}
    </div>
  );
};
